(() => {
  const targetHandle = 'custom-business-stickers-product-labels-square-round-rectangle';
  const targetUrl = `/products/${targetHandle}?artwork=required`;
  let checking = false;

  const missingArtwork = async () => {
    try {
      const response = await fetch('/cart.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) return false;
      const cart = await response.json();
      return cart.items.some(item => item.handle === targetHandle && !(item.properties && item.properties.Artwork));
    } catch (_) {
      return false;
    }
  };

  const goToArtwork = () => {
    window.alert('Artwork is required for your custom sticker order. Please upload your artwork before checkout.');
    window.location.assign(targetUrl);
  };

  document.addEventListener('click', async event => {
    const checkout = event.target.closest('button[name="checkout"], input[name="checkout"], a[href^="/checkout"], [data-cart-checkout]');
    if (!checkout || checking) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    checking = true;
    const missing = await missingArtwork();
    checking = false;
    if (missing) {
      goToArtwork();
      return;
    }
    if (checkout.tagName === 'A' && checkout.href) window.location.assign(checkout.href);
    else window.location.assign('/checkout');
  }, true);

  document.addEventListener('submit', async event => {
    const form = event.target;
    const submitter = event.submitter;
    const isCheckout = submitter?.name === 'checkout' || /\/checkout(?:\?|$)/.test(form.action || '');
    if (!isCheckout || checking) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    checking = true;
    const missing = await missingArtwork();
    checking = false;
    if (missing) goToArtwork();
    else window.location.assign('/checkout');
  }, true);
})();
